import * as React from 'react'
import {
  convertToRegularBarcodeIfBatch,
  isBatchBarcode,
  getBatchNameFromBarcode,
} from '@getgreenline/homi-shared'

interface Props {
  onBarcodeEnter: (value: string, batchNumber?: string) => void
}

// @deprecated
// Use `BarcodeStore` class instead
export class BarcodeListener extends React.Component<Props, {}> {
  readonly minimumNumberOfCharacters = 3
  readonly timeout = 100 // Amount of milliseconds between keystrokes before clearing the barcode character array. Socket mobile averages 20-40ms per keystroke
  private characters: string[] = []

  timer: any

  constructor(props: Props) {
    super(props)
    // Removing event listeners in React
    // Reference: https://gist.github.com/Restuta/e400a555ba24daa396cc
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  componentDidMount() {
    console.log('Listening for barcodes...')
    // Reference: https://stackoverflow.com/questions/19278037/javascript-non-unicode-char-code-to-unicode-character
    window.addEventListener('keypress', this.handleKeyDown)
  }

  handleKeyDown(e: KeyboardEvent) {
    const allowedRegex = /^[a-zA-Z0-9-\s]*$/
    clearTimeout(this.timer)
    if (String.fromCharCode(e.which) && allowedRegex.test(String.fromCharCode(e.which))) {
      this.characters.push(String.fromCharCode(e.which))
    }
    this.timer = setTimeout(() => {
      if (this.characters.length >= this.minimumNumberOfCharacters) {
        const barcode = this.characters.join('')
        // Reference: https://stackoverflow.com/questions/24205193/javascript-remove-zero-width-space-unicode-8203-from-string
        const cleanedBarcode = barcode
          .replace(/\u200B/g, '')
          .replace(/(\r\n|\n|\r)/gm, '')
          .trim()
        if (cleanedBarcode.length > this.minimumNumberOfCharacters) {
          const convertedBarcode = convertToRegularBarcodeIfBatch(cleanedBarcode)
          console.log(`Barcode: ${convertedBarcode}`)
          if (isBatchBarcode(cleanedBarcode)) {
            console.log(`Converted from batch: ${convertedBarcode}`)
          }
          this.props.onBarcodeEnter(convertedBarcode, getBatchNameFromBarcode(cleanedBarcode))
        }
      }
      this.characters = []
    }, this.timeout)
  }

  componentWillUnmount() {
    console.log('Stopped listening for barcodes.')
    window.removeEventListener('keypress', this.handleKeyDown)
  }

  render() {
    return <div />
  }
}
